import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

// Count of upcoming, published group events per therapy_tag id.
export const useTherapyEventCounts = () => {
  return useQuery({
    queryKey: ['therapy-event-counts'],
    staleTime: 5 * 60 * 1000,
    queryFn: async () => {
      const { data, error } = await supabase
        .from('group_events')
        .select('therapy_tag_ids')
        .eq('status', 'published')
        .gte('event_date', new Date().toISOString());
      if (error) throw error;
      const map = new Map<string, number>();
      for (const row of data || []) {
        const ids = (row as any).therapy_tag_ids as string[] | null;
        if (!ids) continue;
        for (const id of ids) map.set(id, (map.get(id) || 0) + 1);
      }
      return map;
    },
  });
};
